import './notification.css'
import { useNotification } from '../state/ui'

export default function Notification() {
  const notification = useNotification()

  return (
    <div className={notification.classes} style={{ backgroundColor: notification.color }}>
      <div className="notificationMessage">{notification.message}</div>
    </div>
  )
}
